import { DropdownSelect } from '@components/_SiteWide/Form/DropdownSelect'
import { FormInput } from '@components/_SiteWide/Form/FormInput'
import { handleSubmit } from '@components/Admin/TankStrategy/helpers'
import {
  DataItem,
  ErrorNotification,
  GraviButton,
  GraviGrid,
  Horizontal,
  Texto,
  Vertical,
} from '@gravitate-js/excalibrr'
import { Col, Drawer, Form, Row } from 'antd'
import { useMemo } from 'react'

export function BulkChangeDrawer({
  setIsBulkChangeVisible,
  isBulkChangeVisible,
  columnDefs,
  selectedRows,
  refreshAndDeselect,
  tankMetadata,
  isDemandModelAvailable,
}) {
  const [form] = Form.useForm()
  const drawerColumnDefs = useMemo(() => {
    const columnCopy = [...columnDefs]
    columnCopy[0] = {
      ...columnCopy[0],
      checkboxSelection: false,
      headerCheckboxSelection: false,
      headerCheckboxSelectionFilteredOnly: false,
    }
    return columnCopy
  }, [columnDefs])

  return (
    <Drawer
      placement='bottom'
      onClose={() => setIsBulkChangeVisible(false)}
      open={isBulkChangeVisible}
      title='Bulk Strategy Change'
      height='80vh'
      bodyStyle={{ padding: '0px' }}
      destroyOnClose
    >
      <Form
        form={form}
        style={{ height: '100%' }}
        onFinish={(formData) => {
          handleSubmit(formData, selectedRows).then(() => {
            refreshAndDeselect()
            setIsBulkChangeVisible(false)
          })
        }}
        onFinishFailed={ErrorNotification}
      >
        <Vertical flex='1'>
          <div className='p-3  bg-theme2 bg-3'>
            <Texto category='p2' appearance='white'>
              <b>Selected Rows - </b> You have selected the following rows to modify:
            </Texto>
          </div>
          <div className='p-3' style={{ flex: 1 }}>
            <GraviGrid
              controlBarProps={{
                title: 'Selected Rows',
              }}
              sideBar={false}
              agPropOverrides={{
                columnDefs: drawerColumnDefs,
                getRowId: (row) => row.data?.key,
              }}
              rowGroupPanelShow='never'
              storageKey='tank-strategies'
              rowData={selectedRows}
            />
          </div>
          <div
            style={{ background: 'var(--theme-color-2-dim)', width: 1200, alignSelf: 'center' }}
            className=' bordered round-border p-3 m-3'
          >
            <Texto category='heading' appearance='secondary'>
              Override Properties
            </Texto>

            <Row>
              <Col className='title' span={6} align='left'>
                <DataItem label='Strategy'>
                  <DropdownSelect
                    required={false}
                    name='inventory_strategy'
                    width='95%'
                    editable
                    options={tankMetadata?.inventory_strategies}
                    data-cy='inventory_strategy_dropdown'
                  />
                </DataItem>
              </Col>
              <Col className='title' span={6} align='left'>
                <DataItem label='Target Min'>
                  <FormInput required={false} editable name='target_min' width='95%' data-cy='target_min_input' />
                </DataItem>
              </Col>
              <Col className='title' span={6} align='left'>
                <DataItem label='Target Max'>
                  <FormInput required={false} editable name='target_max' width='95%' data-cy='target_max_input' />
                </DataItem>
              </Col>
              <Col className='title' span={6} align='left'>
                <DataItem label='Min Load Size'>
                  <FormInput
                    required={false}
                    editable
                    name='minimum_load_size'
                    width='95%'
                    data-cy='min_load_size_input'
                  />
                </DataItem>
              </Col>
            </Row>
            <Row>
              <Col className='title' span={8} align='left'>
                <DataItem label='Max Load Size'>
                  <FormInput
                    required={false}
                    editable
                    name='maximum_load_size'
                    width='95%'
                    data-cy='max_load_size_input'
                  />
                </DataItem>
              </Col>
              <Col className='title' span={8} align='left'>
                <DataItem label='Split Me'>
                  <DropdownSelect
                    required={false}
                    name='is_split_me'
                    width='95%'
                    editable
                    options={['Yes', 'No']}
                    data-cy='split_me_dropdown'
                  />
                </DataItem>
              </Col>
              <Col className='title' span={8} align='left'>
                <DataItem label='Tags'>
                  <DropdownSelect
                    required={false}
                    name='load_tags'
                    width='95%'
                    editable
                    mode='multiple'
                    options={tankMetadata?.tags}
                    data-cy='load_tags_dropdown'
                  />
                </DataItem>
              </Col>
            </Row>
            {isDemandModelAvailable && (
              <Row>
                <Col className='title' span={8} align='left'>
                  <DataItem label='Demand Model Profile'>
                    <DropdownSelect
                      required={false}
                      name='demand_model_tank_profile'
                      width='95%'
                      editable
                      options={tankMetadata?.demand_model_tank_profiles}
                      data-cy='demand_model_tank_profile_dropdown'
                    />
                  </DataItem>
                </Col>
              </Row>
            )}
          </div>
          <Vertical flex='0' justifyContent='flex-end' style={{ minHeight: 70 }}>
            <Horizontal verticalCenter className='p-3 bg-3'>
              <Texto style={{ flex: 1 }} category='p2' weight='bold'>
                <b>Save Bulk Change - </b> Fields not entered will lock in existing values.
              </Texto>
              <GraviButton className='mr-3' buttonText='Cancel' onClick={() => setIsBulkChangeVisible(false)} />
              <GraviButton buttonText='Save Bulk Changes' theme2 onClick={form.submit} />
            </Horizontal>
          </Vertical>
        </Vertical>
      </Form>
    </Drawer>
  )
}
